//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { NavigationItemState } from './Enums';

export class TeacherNavigationPreferencesUpdateItem extends ItemBase {
    ShowPackages?: NavigationItemState;
    ShowExpensesRevenue?: NavigationItemState;
    ShowDirectory?: NavigationItemState;
    ShowOnlineResources?: NavigationItemState;
    ShowBusinessReports?: NavigationItemState;
    ShowWebsite?: NavigationItemState;
    ShowHomeworkSubmission?: NavigationItemState;
    ShowRepertoire?: NavigationItemState;
    ShowLendingLibrary?: NavigationItemState;
    ShowNewsPosts?: NavigationItemState;
    ShowMileage?: NavigationItemState;

    constructor(initializer?: Partial<TeacherNavigationPreferencesUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherNavigationPreferencesUpdateItem";
}
